export default __webpack_public_path__ + "static/media/battlemage.0f326f0c.png";